import styled from "styled-components";
import { ItemContainerStyled } from "./ItemContainerStyled";
export const ItemHidableStyled = styled.div`
    opacity: 0;

    ${ItemContainerStyled}:hover & {
        opacity: 1;
    }

    ${ItemContainerStyled} &:hover {
        opacity: 0.8;
    }
`;
